module.exports = __webpack_public_path__ + "static/img/greeting.1415c1c5.png";